// extracted by mini-css-extract-plugin
module.exports = {"otpinput":"OTPInput_otpinput__3plsT"};